import { render } from "./RulerY.vue?vue&type=template&id=1beffa4e&scoped=true&ts=true"
import script from "./RulerY.vue?vue&type=script&lang=ts"
export * from "./RulerY.vue?vue&type=script&lang=ts"

import "./RulerY.vue?vue&type=style&index=0&id=1beffa4e&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1beffa4e"]])

export default __exports__